export function sliderSection() {
    const $slider = $(".slider-section .slider");
    let sliderNav = "";
    
    $slider.each(function (i, it) {
        const $this = $(this);
        if ($this.siblings(".slider-nav").length > 0) {
            sliderNav = $this.siblings(".slider-nav");
        }
        $(it).slick({
            appendArrows: sliderNav,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            nextArrow: "<button class=\"slide-arrow slick-next\" aria-label=\"button-next\"><svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                "<rect width=\"40\" height=\"40\" rx=\"20\" fill=\"white\"/>\n" +
                "<path d=\"M18 14L24 20L18 26\" stroke=\"black\" stroke-width=\"1.5\" stroke-linejoin=\"bevel\"/>\n" +
                "</svg>\n</button>",
            prevArrow: "<button class=\"slide-arrow slick-prev\" aria-label=\"button-prev\"><svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                "<rect width=\"40\" height=\"40\" rx=\"20\" fill=\"white\"/>\n" +
                "<path d=\"M22 14L16 20L22 26\" stroke=\"black\" stroke-width=\"1.5\" stroke-linejoin=\"bevel\"/>\n" +
                "</svg>\n</button>",
                
        });
    });
};



// WEBPACK FOOTER //
// ./assets/js/modules/sliderSection.js